import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full h-[80vh] min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-36">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/wscy1t9YQotjsDPq4EPTZn/circle_barber_shop_joey_pic.png')"
    }} data-id="element-37" />
      <div className="absolute inset-0 bg-[#0a0a0a]/80" data-id="element-38" />
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-39">
        <p className="font-['Source_Sans_3'] text-[#c9a84c] text-sm md:text-base uppercase tracking-[0.3em] mb-4" data-id="element-40">
          Est. 1948
        </p>
        <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl text-white font-bold leading-tight tracking-wide" data-id="element-41">
          {t.hero.headline}
        </h1>
      </div>
    </section>;
}